import React from 'react'
import { KeywordDetailsProvider } from 'pages/keywords/context'
import { KeywordDetails } from './KeywordDetails'

export const ViewKeyword = () => (
  <KeywordDetailsProvider>
    <KeywordDetails />
  </KeywordDetailsProvider>
)
